import { LOCALE_SET } from "../actions/constants/auth";

export default function localeReducer(state = { lang: "pl" }, action: any) {
  switch (action.type) {
    case LOCALE_SET:
      return { lang: action.lang };
    default:
      return state;
  }
}
